<template>
  <el-form
    :model="form"
    :inline="inline"
    label-width="120px"
    :rules="rules"
    ref="formRef"
  >
    <template v-for="(item, index) in formList">
      <template v-if="item.title || item.form">
        <div class="item-title" v-if="item.title" :key="index">
          <el-icon>
            <CaretRight />
          </el-icon>
          {{ item.title }}
        </div>
        <template v-for="(f, fIndex) in item.form">
          <el-form-item
            :key="fIndex"
            :label="f.label"
            :prop="f.value"
            v-if="f.showCondition ? f.showCondition(form) : true"
          >
            <!-- @slot el-form-item内的插槽名  -->
            <slot :name="f.slot" v-if="f.slot" />
            <component
              v-else
              v-bind="f"
              v-bind:value="form[f.value]"
              v-model="form[f.value]"
              :is="f.component ? f.component : 'el-input'"
              :placeholder="f.placeholder ? f.placeholder : '请输入'"
              :params="f.getParams ? f.getParams(form) : f?.params ?? null"
              :rowKey="f?.rowKey ?? 'id'"
            >
              <template v-if="f.prepend" #prepend>{{ f.prepend }}</template>
              <template v-if="f.append" #append>{{ f.append }}</template>
            </component>
          </el-form-item>
        </template>
        <template v-if="item.slot">
          <!-- @slot 用户自定义插入el-form-item的插槽名  -->
          <slot :name="item.slot"></slot>
        </template>
      </template>
    </template>
  </el-form>
</template>
<script>
import {
  getCurrentInstance,
  defineComponent,
  ref,
  provide,
  reactive,
  onMounted,
  watch,
  toRefs,
  computed,
} from "vue";

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
export default defineComponent({
  name: "basicForm",
  components: {},
  props: {
    /** form数组
     * @values {form:[{label,value,showCondition,...}],title:"string",slot:""}
     * */
    formList: {
      type: Array,
      default: () => [],
      required: true,
    },
    /** 校验规则，同el-form的校验传参一致*/
    rules: {
      type: Object,
      default: () => {
        return {};
      },
    },
    /** 行内表单模式
     * @values true / false
     * */
    inline: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const formRef = ref();
    const state = reactive({
      form: {},
    });
    onMounted(() => {
      props.formList.forEach((item) => {
        if (item.form && item.form.length > 0) {
          item.form.forEach((f) => {
            if (f.value) {
              state.form[f.value] = f.defaultValue ? f.defaultValue : null;
            }
          });
        }
      });
    });
    return {
      ...toRefs(state),
      formRef,
    };
  },
});
</script>
<style scoped lang="less"></style>
<docs lang="md">
### props

###### formList.slot

- 用户自定义插入 el-form-item 的插槽名

###### formList.form item

- @param {string} label - 必传,标签文本
- @param {string} value - 必传,组件 model 的键名
- @param {string} component - 默认为 el-input
- @param {string} slot - el-form-item 内的插槽名
- @param {function} showCondition - 控制 el-form-item,参数为 form
- @param {function} getParams -给 params 传参
- @param element 组件的其他参数
</docs>
